import { render, staticRenderFns } from "./UiWidget.vue?vue&type=template&id=136de577&scoped=true"
import script from "./UiWidget.vue?vue&type=script&lang=js"
export * from "./UiWidget.vue?vue&type=script&lang=js"
import style0 from "./UiWidget.vue?vue&type=style&index=0&id=136de577&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136de577",
  null
  
)

export default component.exports